import React from 'react'
import AddInventoryItemsToEditDialogViewModel, {
  EditScopeChangeInventoryItemToAdd,
} from './AddInventoryItemsToEditDialogViewModel'
import styles from './AddInventoryItemsToEditDialog.sass'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeaderCloseButton,
  ModalSheetHeaderShell,
  ModalSheetTitle,
} from 'components/ModalSheet'
import { observer } from 'mobx-react'
import InfiniteScrollLoader from 'components/InfiniteScrollLoader'
import SearchField from 'components/SearchField'
import cx from 'classnames'
import Checkbox from 'components/Checkbox'
import Button from 'components/Button'

interface Props {
  vm: AddInventoryItemsToEditDialogViewModel
}

export default observer(function AddInventoryItemsToEditDialog({ vm }: Props) {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeaderShell size="auto">
        <div className={styles.header}>
          <div className={styles.closeButtonContainer}>
            <ModalSheetTitle>Add service items</ModalSheetTitle>
            <ModalSheetHeaderCloseButton />
          </div>
          <div className={styles.searchContainer}>
            <SearchField
              autoFocus
              stretch
              className={styles.scopeSearch}
              placeholder="Type to search service items"
              onChange={vm.searchText.change}
              value={vm.searchText.value}
            />
          </div>
        </div>
      </ModalSheetHeaderShell>

      <ModalSheetContent>
        <div className={styles.itemsContainer}>
          {vm.serviceItems.map((item) => {
            return <InventoryItemListItem key={item.versionId} item={item} />
          })}
          <InfiniteScrollLoader
            compact
            scrollProvider={vm.inventoryScrollProvider}
          />
        </div>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.close} type="default">
            Close
          </Button>
          <Button
            onClick={vm.addItems}
            type="primary"
            dataTest="scope-change-request-edit"
            disabled={vm.selectedInventoryItems.length <= 0}
          >
            Assign {vm.selectedInventoryItems.length}
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

const InventoryItemListItem = observer(function InventoryItemListItem({
  item,
}: {
  item: EditScopeChangeInventoryItemToAdd
}) {
  return (
    <div
      className={cx(styles.itemContainer, item.selected && styles.selected)}
      onClick={item.toggleSelected}
      data-test={`scope-change-inventory-item-${item.name}`}
    >
      <div className={styles.checkboxContainer}>
        <Checkbox checked={item.selected} />
      </div>

      <div className={styles.textContainer}>
        <div className={styles.title}>{item.name}</div>
        <div className={styles.description}>{item.description}</div>
      </div>
    </div>
  )
})
